/* eslint-disable no-script-url */
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'

import KGroupsTree from '@/components/UI/KGroupsTree'
import BasicModal from '../Dialog'

const MoveSelectedModal = (props: any) => {
  const { t } = useTranslation('translation')
  const [selectedGroupId, setSelectedGroupId] = useState(null)
  const [isGroupValid, setIsGroupValid] = useState(false)

  useEffect(() => {
    if (!props.show) {
      return
    }
    setSelectedGroupId(props?.groupId ? props.groupId : null)
    setIsGroupValid(selectedGroupId && selectedGroupId !== 'undefined')
  }, [props.show])

  useEffect(() => {
    if (
      props?.initialSelectedGroupId &&
      props.initialSelectedGroupId === selectedGroupId
    ) {
      setIsGroupValid(false)
    }
  }, [selectedGroupId])

  const confirmCategoryUpdatehandler = (extraParams: boolean = false) => {
    props.confirmCategoryUpdate(selectedGroupId, extraParams)
  }

  return (
    <>
      <BasicModal
        open={props.show}
        onClose={props.onHide}
        sx={{ width: 800, height: 'auto' }}
        title={props?.title || t('Save objects to')}
        footerActions={
          props.summarisedView
            ? [
                {
                  title: t('Save without creating Flow'),
                  variant: 'outlined',
                  onClick: () => {
                    if (!isGroupValid) {
                      return
                    }
                    confirmCategoryUpdatehandler(false)
                  },
                  disabled: !isGroupValid,
                },
                {
                  title: t('Save and Create Flow'),
                  variant: 'contained',
                  onClick: () => {
                    if (!isGroupValid) {
                      return
                    }
                    confirmCategoryUpdatehandler(true)
                  },
                  disabled: !isGroupValid,
                },
              ]
            : [
                {
                  title: `${props.isBuildKnowledge ? t('Save and Proceed') : t('Save')}`,
                  variant: 'contained',
                  onClick: () => {
                    if (!isGroupValid) {
                      return
                    }
                    confirmCategoryUpdatehandler(false)
                  },
                  disabled: !isGroupValid,
                },
              ]
        }
      >
        <KGroupsTree
          title={t('Knowledge Groups')}
          onSelectGroup={group => {
            setSelectedGroupId(group?._id || null)
            setIsGroupValid(group?._id && group?._id !== 'undefined')
          }}
          syncsState={false}
          initialSelectedGroupId={props?.groupId}
          hidesSystemGroups={true}
        />
      </BasicModal>
    </>
  )
}

export default MoveSelectedModal
